import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  row: {
    borderBottom: `${theme.spacing(0.125)}px solid ${theme.palette.black.light}`,
  },
  cell: {
    padding: theme.spacing(1.25),
    ...theme.typography.h6,
    backgroundColor: theme.palette.black.lighter,
    cursor: 'pointer',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre',
  },
  icon: {
    marginLeft: theme.spacing(1),
    height: theme.spacing(1.5),
  },
}));
